export default {"src":"/_next/static/media/MenuFilter.4f6ad0b7.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};